import React from 'react';

import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import { ReactionsSummaryViewPlaceholder } from '../src/ReactionsSummaryViewPlaceholder.tsx';
import { ReactionsPlaceholder } from '../src/ReactionsPlaceholder.tsx';
import type { ReactionsProps } from '../src/Reactions.tsx';

export const ReactionsSSRLoader: LoadableType<ReactionsProps> = LoadableAfterPaint({
	loading: (props) => {
		return props?.summaryViewEnabled ? (
			<ReactionsSummaryViewPlaceholder />
		) : (
			<ReactionsPlaceholder />
		);
	},
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Reactions" */ '../src/Reactions.tsx')).Reactions,
});
